import { SchoolLevelType } from '@asset/enum/school';
import { StudyManagementListFilterOrderInfo } from '@asset/type/studyManagement';
import { DateTime } from 'luxon';

import qs from 'qs';
import { ParsedUrlQueryInput } from 'querystring';
import { UrlObject } from 'url';

export const MY_CLASS_URL_PREFIX = '/manage/my-class';
export const MY_CLASS_MAIN_URL_PREFIX = `${MY_CLASS_URL_PREFIX}/main`;
export const MY_STUDY_CLASS_URL_PREFIX = '/manage/my-study-class';

export const MANAGE_SCHOOL_URL_PREFIX = '/manage/school';

export const MANAGE_QUESTION_DETAIL_URL_PREFIX =
  '/manage/student/question/detail';

export const getCreateStudentPageUrlObject = (): UrlObject => {
  const urlString = `/manage/student/create`;
  return { pathname: urlString };
};

export const getMyClassMainPageUrlObject = (): UrlObject => {
  const urlString = MY_CLASS_MAIN_URL_PREFIX;
  return { pathname: urlString };
};

export const getStudyClassListPageUrlObject = (query?: {
  mainTeacherIds?: number[];
  pageNumber?: number;
}): UrlObject => {
  const urlString = `${MY_STUDY_CLASS_URL_PREFIX}/list`;
  const queryString = qs.stringify(
    {
      mainTeacher: query?.mainTeacherIds ?? undefined,
      pageNumber: query?.pageNumber ?? undefined,
    },
    {
      skipNulls: true,
      arrayFormat: 'comma',
    },
  );
  if (queryString) {
    return {
      pathname: urlString,
      query: qs.parse(queryString) as ParsedUrlQueryInput,
    };
  }
  return { pathname: urlString };
};

export const getStudyClassDetailRoadmapPageUrlObject = (
  studyClassId: number,
): UrlObject => {
  const urlString = `${MY_STUDY_CLASS_URL_PREFIX}/${studyClassId}/roadmap`;
  return { pathname: urlString };
};

export const getStudyClassDetailCalendarPageUrlObject = (
  studyClassId: number,
): UrlObject => {
  const urlString = `${MY_STUDY_CLASS_URL_PREFIX}/${studyClassId}/calendar`;
  return { pathname: urlString };
};

export const getStudyClassDetailSchedulePageUrlObject = (
  studyClassId: number,
  query?: { startDate?: DateTime },
): UrlObject => {
  const urlString = `${MY_STUDY_CLASS_URL_PREFIX}/${studyClassId}/schedule`;
  const queryString = qs.stringify(
    { ...query, startDate: query?.startDate.toISO() },
    { skipNulls: true },
  );
  if (queryString) {
    return {
      pathname: urlString,
      query: qs.parse(queryString) as ParsedUrlQueryInput,
    };
  }
  return { pathname: urlString };
};

export const getStudyClassDetailSettingPageUrlObject = (
  studyClassId: number,
): UrlObject => {
  const urlString = `${MY_STUDY_CLASS_URL_PREFIX}/${studyClassId}/setting`;
  return { pathname: urlString };
};

export const getStudyManagementPageUrlObject = (
  query?: StudyManagementListFilterOrderInfo & {
    pageNumber?: number;
  },
): UrlObject => {
  const urlString = '/manage/study-management';
  const queryString = qs.stringify(
    {
      week: query?.week?.toISO(),
      student: query?.studentIds,
      teacher: query?.teacherIds,
      pageNumber: query?.pageNumber,
    },
    { skipNulls: true, arrayFormat: 'comma' },
  );
  if (queryString) {
    return {
      pathname: urlString,
      query: qs.parse(queryString) as ParsedUrlQueryInput,
    };
  }
  return { pathname: urlString };
};

export const getSchoolListPageUrlObject = (query?: {
  pageNumber?: number;
  search?: string;
  schoolLevelType?: SchoolLevelType[];
}): UrlObject => {
  const urlString = `${MANAGE_SCHOOL_URL_PREFIX}/list`;
  const queryString = qs.stringify(query, {
    skipNulls: true,
    arrayFormat: 'comma',
  });
  if (queryString) {
    return {
      pathname: urlString,
      query: qs.parse(queryString) as ParsedUrlQueryInput,
    };
  }
  return { pathname: urlString };
};

export const getSchoolDetailPageUrlObject = (schoolId: number): UrlObject => {
  const urlString = `${MANAGE_SCHOOL_URL_PREFIX}/detail/${schoolId}`;
  return { pathname: urlString };
};

export const getSchoolCreatePageUrlObject = (): UrlObject => {
  const urlString = `${MANAGE_SCHOOL_URL_PREFIX}/create`;
  return { pathname: urlString };
};
